export default class Client {
  /**
   * @type {number}
   */
  id;

  /**
   * @type {string}
   */
  firstName;

  /**
   * @type {string}
   */
  lastName;

  /**
   * @type {string}
   */
  cellPhone;

  /**
   * @type {string}
   */
  emailAddress;

  /**
   * @type {boolean}
   */
  verified = false;

  /**
   * @type {number}
   */
  selectedOfficeId;

  /**
   * @type {number}
   */
  threePClientId;

  /**
   * @type {object}
   */
  createdDate;

  /**
   * @type {object}
   */
  signupCompletionDate;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.id != null) {
        this.id = opts.id;
      }
      if (opts.firstName != null) {
        this.firstName = opts.firstName;
      }
      if (opts.lastName != null) {
        this.lastName = opts.lastName;
      }
      if (opts.cellPhone != null) {
        this.cellPhone = opts.cellPhone;
      }
      if (opts.emailAddress != null) {
        this.emailAddress = opts.emailAddress;
      }
      if (opts.verified != null) {
        this.verified = opts.verified;
      }
      if (opts.selectedOfficeId != null) {
        this.selectedOfficeId = opts.selectedOfficeId;
      }
      if (opts.threePClientId != null) {
        this.threePClientId = opts.threePClientId;
      }
      if (opts.createdDate != null) {
        this.createdDate = opts.createdDate;
      }
      if (opts.signupCompletionDate != null) {
        this.signupCompletionDate = opts.signupCompletionDate;
      }
    }
  }
}
